import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function SeoLinks() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.fastAffiliationSeo.updateLinks(pathname);
  }, [pathname]);
  return null;
}
